/* Component to update status */
import React, { useEffect, useRef, useState } from "react"

import Form from "react-bootstrap/Form"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import styles from "../../styles/Indexes.module.css"
import Alert from "react-bootstrap/Alert"
import { axiosReq, axiosInstance } from "../../api/axiosDefaults"
import useHostName from "../../hooks/useHostName"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import toast from "react-hot-toast";

const ProTrackStatEdit = ({ setShowStat, setproTrackers, status1, id, tracker }) => {
  const host = useHostName()
  const isMountedRef = useRef(false)
  const [errors, setErrors] = useState({})

  const [postData, setPostData] = useState({
    status: status1,
  })
  const [isUpdating, setIsUpdating] = useState(false)

  const { status } = postData

  useEffect(() => {
    isMountedRef.current = true

    return () => {
      isMountedRef.current = false
    }
  }, [])

  const parseScene = (source) => {
    const rawScene = source?.scene ?? null
    if (rawScene == null || rawScene === "") return null
    const parsed = Number(rawScene)
    return Number.isFinite(parsed) ? parsed : null
  }

  const buildPayload = (source, nextStatus) => ({
    scene: parseScene(source),
    name: source?.name ?? "",
    department: source?.department ?? "",
    level: source?.level ?? "",
    status: nextStatus,
    done_by: source?.done_by ?? null,
    episode: source?.episode ?? null,
  })

  const updateStatus = async (nextStatus) => {
    setIsUpdating(true)
    setErrors({})
    try {
      const payload = buildPayload(tracker || {}, nextStatus)
      if (!payload.name || payload.scene == null) {
        throw new Error("Unable to update status because tracker item data is incomplete.")
      }

      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const response = await axiosReq.put(
          `/production-tracker/items/${id}/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        if (response?.success === false) {
          throw response.error
        }
        const updated = response?.data || {}
        const updatedStatus = updated?.status ?? nextStatus ?? status
        setproTrackers((prevTracks) => ({
          ...prevTracks,
          results: prevTracks.results.map((track) =>
            track.id === id
              ? {
                  ...track,
                  ...updated,
                  status: updatedStatus,
                }
              : track
          ),
        }))
        if (isMountedRef.current) {
          setShowStat(false)
        }
      } else {
        const response = await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/production-tracker/items/${id}/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (response?.success === false) {
          throw response.error
        }
        const updated = response?.data || {}
        const updatedStatus = updated?.status ?? nextStatus ?? status
        setproTrackers((prevTracks) => ({
          ...prevTracks,
          results: prevTracks.results.map((track) => {
            return track.id === id
              ? {
                  ...track,
                  ...updated,
                  status: updatedStatus,
                }
              : track
          }),
        }))
        if (isMountedRef.current) {
          setShowStat(false)
        }
      }
       toast.success(`Status Updated Successfully!`);
    } catch (err) {
      console.log(err)
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.message ||
        "Failed to update status."
      toast.error(backendError)
      if (isMountedRef.current && err.response?.status !== 401) {
        setErrors(err.response?.data || {})
      }
    } finally {
      if (isMountedRef.current) {
        setIsUpdating(false)
      }
    }
  }

  const handleStatusChange = async (event) => {
    const nextStatus = event.target.value
    setPostData((prev) => ({
      ...prev,
      status: nextStatus,
    }))
    if (nextStatus === status || isUpdating) return
    await updateStatus(nextStatus)
  }

  return (
    <div className="pt-3">
    <Row>
    <Col xs={{span: 12}} sm={{span: 6}} md={{span: 4}}
    className={`${styles.BackStatus } px-0 text-center`}>
    <Form>
    <Row className="d-flex align-items-center">
    <Col xs={6} className="px-3" >
    <div className="d-flex justify-content-center">
        <Form.Group controlId="stat" className={`${styles.Width100}`} >
              <Form.Control as="select"
                className={styles.Input}
                name="status"
                value={status}
                onChange={handleStatusChange}
                disabled={isUpdating}
                aria-label="stat select">
                <option className={`${styles.StatsNew}`} value="new">New</option>
                <option className={`${styles.StatsStart}`} value="started">Started</option>
                <option className={`${styles.StatsDone}`} value="done">Done</option>
              </Form.Control>
          </Form.Group>
          {errors?.status?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
    </div>
    </Col>
    </Row>    
    </Form>
    </Col>
    </Row>
    </div>
  )
}

export default ProTrackStatEdit
